import { generatePath } from 'react-router-dom'
import { DOCUMENT, HUB } from 'routes'
import { IProject } from 'types'

/**
 * A hub's front page: its default document. Without one, the hub route decides
 * (it opens settings).
 */
export const hubHomePath = (project: Pick<IProject, 'publicId' | 'defaultProcessId'>): string =>
  project.defaultProcessId
    ? generatePath(DOCUMENT, { projectId: project.publicId, processId: project.defaultProcessId })
    : generatePath(HUB, { projectId: project.publicId })
